<!--
 * @Description: 我的订单 - 已结算
 * @Date: 2019-09-02 09:48:51
 -->

<!--用户管理-->
<template>
  <div class="table-box">
    <!--查询-->
    <div class="search-box">
      <div class="search-left">
        <div>
          <span>任务月度:</span>
          <el-date-picker
            @change="dateChange"
            range-separator="-"
            value-format="yyyy-MM"
            type="month"
            v-model="searchQuery.taskDate"
          ></el-date-picker>
        </div>
        <div>
          <span>支付状态:</span>
          <el-select
            v-model="searchQuery.orderStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="(item, index) in payList"
              :key="index"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="search-right">
        <el-button type="primary" @click="searchEvent">查询</el-button>
      </div>
    </div>
    <!--列表-->
    <div class="">
      <el-table
        v-loading="loading"
        :data="tableData"
        border=""
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
      >
        <el-table-column
          prop="orderNo"
          label="订单编号"
          align="center"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="chargeDt"
          label="任务月度"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="认证信息服务费"
        >
          <template slot-scope="scope">
            <div
              style="display:flex;justify-content:space-around;align-items:center;"
            >
              <span>{{ scope.row.orderPrice | moneyFixed }}</span>
              <el-button
                type="text"
                @click="showComponent('qualifyDetail', scope.row)"
              >
                详情
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="本次需打款总金额"
          width="120"
        >
          <template slot-scope="scope">
            <div
              style="display:flex;justify-content:space-around;align-items:center;"
            >
              <span>{{ scope.row.orderPrice | moneyFixed }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="支付状态"
          width="180"
        >
          <template slot-scope="scope">
            <div
              style="display:flex;justify-content:space-around;align-items:center;"
            >
              <span>{{ scope.row.orderStatus | transStatus }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="showComponent('confirmPay', scope.row)"
            >
              {{ payStatusHandlerName(scope.row.orderStatus) }}
            </el-button>
            <el-button
              type="text"
              :disabled="scope.row.orderStatus != 2"
              @click="downloadFile(scope.row)"
            >
              下载回单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
    </div>
    <component
      :is="componentName"
      :show-dialog="showDetail"
      :activeTask="activeTask"
    ></component>
    <pay-detail></pay-detail>
  </div>
</template>

<script>
import payDetail from './payDetail.vue';
import qualifyDetail from './qualifyDetail.vue';
import serviceDetail from './serviceDetail.vue';
import confirmPay from './otherConfirmPay.vue';
import { authOrderList, otherDownBack } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect';
import datePicker from '@/Mixin/datePicker';
import { projectOrderPayStatus } from '@/config/staticData';

export default {
  mixins: [pageInation, makeSure, datePicker],
  data() {
    return {
      projectOrderPayStatus,
      ruleForm: {
        taskDate: ''
      }, // 用户信息
      getList: authOrderList, // 获取列表的AJAX
      searchQuery: {
        taskDate: '',
        orderStatus: ''
      },
      // searchAjax: company.list,
      prop: {
        label: 'enterpriseName',
        code: 'id'
      },
      showDetail: false,
      componentName: '',
      activeTask: 'projectPay',
      item: {
        data: null
      },
      payList: [
        { label: '待支付', key: 0 },
        { label: '支付中', key: 1 },
        { label: '支付成功', key: 2 },
        { label: '支付失败', key: 3 }
      ]
    };
  },
  components: {
    dicSelect,
    payDetail,
    qualifyDetail,
    serviceDetail,
    confirmPay
  },
  provide() {
    return {
      itemData: this.item
    };
  },
  computed: {},
  methods: {
    payStatusHandlerName(payStatus) {
      if (payStatus == 0) {
        return '支付';
      } else {
        return '详情';
      }
    },
    showComponent(componentName, item = null) {
      this.item.data = item;
      this.componentName = componentName;
      this.showDetail = true;
    },
    downloadFile(row) {
      let { chargeDt, orderNo } = row;
      window.open(`${otherDownBack}?payOrderNo=${orderNo}&taskDt=${chargeDt}`);
    }
  },
  filters: {
    transStatus(v) {
      let s = {
        0: '待支付',
        1: '支付中',
        2: '支付成功',
        3: '支付失败'
      };
      return s[v];
    }
  },
  created() {}
};
</script>
